import { advancedExportsAnnouncement } from '../entries/advancedExports'
import { chileautosHighlightsAnnouncement } from '../entries/chileautosHighlights'
import { fiestasPatriasAnnouncement } from '../entries/fiestasPatrias'
import { marginReportAnnouncement } from '../entries/marginReport'
import { vehiclePriceAnnouncement } from '../entries/vehiclePrice'

import type { Announcement } from '../entries/types'

/**
 * Every announcement we have published, newest first.
 *
 * Until now the dialog hardcoded one: each release replaced the last, and the
 * previous journey was deleted with it. Keeping them in a list means the button
 * opens the newest one and still offers the ones before it, so a dealer who
 * joined last month can watch how the margin split works instead of hearing
 * that it was explained once, in August.
 *
 * Adding a release: build an entry under `entries/`, put it at the top here.
 * That is the whole checklist — the head of this list is what auto-opens, and
 * its version is the key that decides who has already seen it.
 */
export const ANNOUNCEMENTS: Announcement[] = [
  chileautosHighlightsAnnouncement,
  fiestasPatriasAnnouncement,
  vehiclePriceAnnouncement,
  marginReportAnnouncement,
  advancedExportsAnnouncement,
]

export const LATEST_ANNOUNCEMENT = ANNOUNCEMENTS[0]

/** The release the app announces right now. */
export const APP_RELEASE = LATEST_ANNOUNCEMENT.version
